import groupProduct from '@/components/group-product/GroupProduct'

export default [
    {
      path: '/groupProduct',
      name: 'groupProduct',
      component: groupProduct,
      meta: {
        requiresAuth: true
      }
    }
  ]


// WEBPACK FOOTER //
// ./src/router/productGroup.js